export const PLUGIN_HOST_CONTEXT = 'dxcore_pluginHost_context';
export const POSITION_CONTEXT = 'dxcore_position_context';
export const TEMPLATE_HOST_CONTEXT = 'dxcore_templateHost_context';

export const RERENDER_TEMPLATE_EVENT = Symbol('rerenderTemplate');
export const RERENDER_TEMPLATE_SCOPE_EVENT = Symbol('rerenderTemplateScope');
export const UPDATE_CONNECTION_EVENT = Symbol('updateConnection');
